import { useContext } from 'react';
import useSWR from 'swr';

import { ChainlitContext, IThread } from '@chainlit/react-client';

const PINNED_THREADS_KEY = 'pinned-threads';

export function usePinnedThreads() {
    const apiClient = useContext(ChainlitContext);

    const { data, error, isLoading, mutate } = useSWR<IThread[]>(
        PINNED_THREADS_KEY,
        async () => {
            const { data } = await apiClient.listThreads(
                { first: 100 },
                { isPinned: true }
            );
            return data || [];
        },
        {
            revalidateOnFocus: false,
            dedupingInterval: 5000
        }
    );

    const refresh = () => mutate();

    return {
        threads: data || [],
        isLoading,
        error,
        refresh
    };
}
